"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = /*#__PURE__*/function () {
  function _default() {
    _classCallCheck(this, _default);

    _defineProperty(this, "estoreLocation", null);

    _defineProperty(this, "siteLocation", null);

    _defineProperty(this, "nameCookiesInternal", []);
  }

  _createClass(_default, [{
    key: "nameCookies",
    get: function get() {
      return this.nameCookiesInternal;
    }
  }, {
    key: "cartUrl",
    get: function get() {
      if (this.cartUrlInternal) {
        return this.cartUrlInternal;
      }

      return "".concat(this.estoreLocation, "/cart");
    },
    set: function set(value) {
      this.cartUrlInternal = value;
    }
  }, {
    key: "loginUrl",
    get: function get() {
      if (this.loginUrlInternal) {
        return this.loginUrlInternal;
      }

      return "".concat(this.siteLocation, "/your-accounts/");
    },
    set: function set(value) {
      this.loginUrlInternal = value;
    }
  }, {
    key: "accountOverviewUrl",
    get: function get() {
      if (this.accountOverviewUrlInternal) {
        return this.accountOverviewUrlInternal;
      }

      return "".concat(this.siteLocation, "/your-accounts/");
    },
    set: function set(value) {
      this.accountOverviewUrlInternal = value;
    }
  }, {
    key: "logoutUrl",
    get: function get() {
      if (this.logoutUrlInternal) {
        return this.logoutUrlInternal;
      }

      return "".concat(this.siteLocation, "/your-accounts/?signout=true");
    },
    set: function set(value) {
      this.logoutUrlInternal = value;
    }
  }]);

  return _default;
}();

exports["default"] = _default;